import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import VnButton from '@ui/components/VnButton';
import { trashOutline, saveOutline, cubeOutline } from 'ionicons/icons';
import { Breadcrumb, Form, Tab, Tabs } from 'react-bootstrap';
import NotesTab from './note/NotesTab';
import InfoTab from './info/InfoTab';
import ContactPersonTab from './contactperson/ContactPersonTab';
import AttachmentsTab from './attachment/AttachmentsTab';
import CreditureTabsHelpers from './creditureHelpers';
import { useAppDispatch } from '@application/store/useStore';
import { createCreditureAsync, deleteCreditureByIdAsync, getCreditureByIdAsync, updateCreditureAsync } from '@application/features/creditures/creditureThunk';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import VnConfirmationModel from '@ui/components/VnConfirmationModel';
import VnNotificationModel from '@ui/components/VnNotificationModel';
import { IonIcon } from '@ionic/react';
import VnDocumentTitle from '@ui/components/VnDocumentTitle';
import { Permission, PermissionType } from '@application/common/enums/role-permission';
import { handleRolePermission } from '@infrastructure/helpers';
import { TabNotification } from '@ui/components/VnTabNotification';
const CreditureView = () => {
    const dispatch = useAppDispatch();
    const { formdata, validateForm, errors, handleFieldChange, handleToggelButtonChange, setFormData, infoTabErrorBorderColor, isInfoTabUnsaved, isNotesTabUnsaved, isInfoTabBold, isNotesTabBold } = CreditureTabsHelpers();
    const [submitCreditures, setSubmitCreditures] = useState(false);
    const [isDeleteDisabled, setIsDeleteDisabled] = useState(true);
    const [isCreditorDeleteConfirmationPopup, setCreditorDeleteConfirmationPopup] = useState(false);
    const [isCreditorDeleteNotificationPopup, setCreditorDeleteNotificationPopup] = useState(false);
    const [creditorDeleteErrorMessage, setCreditorDeleteErrorMessage] = useState('');
    const navigate = useNavigate();
    const { id } = useParams();
    const [activeTab, setActiveTab] = useState('InfoTab');
    const [isAttachmentTabBold, setIsAttachmentTabBold] = useState(false);
    const [isContactPersonTabBold, setIsContactPersonTabBold] = useState(false);
    VnDocumentTitle('Visser Lev-' + formdata.creditorNumber);
    const handleTabChange = (tabKey) => {
        if (tabKey) {
            setActiveTab(tabKey);
        }
    };
    useEffect(() => {
        if (id) {
            dispatch(getCreditureByIdAsync(parseInt(id)))
                .unwrap()
                .then((res) => {
                setIsDeleteDisabled(false);
                setFormData(res);
            })
                .catch((error) => {
                navigate(`/admin/CredituresList`);
                console.error('Bad request.');
            });
        }
    }, [id]);
    const handleSubmit = (event) => {
        event.preventDefault();
        if (submitCreditures) {
            const triggeredErrors = validateForm();
            if (Object.values(triggeredErrors).every((errors) => !errors)) {
                if (!id) {
                    dispatch(createCreditureAsync(formdata))
                        .unwrap()
                        .then((res) => {
                        navigate(`/admin/CreditureTabs/${res.id}`);
                        setIsDeleteDisabled(false);
                    });
                }
                else {
                    dispatch(updateCreditureAsync(formdata))
                        .unwrap()
                        .then((res) => setFormData(res))
                        .catch((error) => {
                        if (error.status === 405) {
                            setCreditorDeleteNotificationPopup(true);
                            setCreditorDeleteErrorMessage(error.error);
                        }
                    });
                }
            }
            setSubmitCreditures(true);
        }
    };
    const handleCreditorDelete = () => {
        if (id) {
            dispatch(deleteCreditureByIdAsync(parseInt(id)))
                .unwrap()
                .then((res) => navigate('/admin/CredituresList'))
                .catch((error) => {
                if (error.status == 405) {
                    setCreditorDeleteNotificationPopup(true);
                    setCreditorDeleteErrorMessage(error.error);
                }
                setCreditorDeleteConfirmationPopup(false);
            });
        }
    };
    const onCancelCreditorDeleteClicked = () => {
        setCreditorDeleteConfirmationPopup(false);
        setCreditorDeleteNotificationPopup(false);
    };
    const handleAttachmentTabBold = (state) => {
        setIsAttachmentTabBold(state);
    };
    const handleContactPersonTabBold = (state) => {
        setIsContactPersonTabBold(state);
    };
    return (_jsx(_Fragment, { children: _jsxs("div", { className: 'mt-1', children: [_jsxs(Form, { onSubmit: handleSubmit, children: [_jsxs("div", { className: 'vn-Workorder-Titlebar', children: [_jsxs("div", { children: [_jsx("h4", { className: 'vn-Workorder-Title', children: "Leveranciers" }), _jsxs(Breadcrumb, { children: [_jsxs(Breadcrumb.Item, { href: '/admin/CredituresList', children: [_jsx("span", { children: _jsx(IonIcon, { icon: cubeOutline, className: 'vn-breadcrum-icon' }) }), "Leveranciers"] }), _jsx(Breadcrumb.Item, { active: true, className: 'breadcrumb-active', children: formdata.creditorNumber })] })] }), _jsxs("div", { className: 'vn-ButtonContainer', children: [_jsx(VnButton, { icon: trashOutline, customClassName: 'vn-action-button', mode: 'danger', size: 'sm', type: 'button', customIconClassName: 'vn-action-button-icon', isDisabled: handleRolePermission(Permission.LEVERANCIERS, PermissionType.Delete) && id ? false : true, onClick: () => {
                                                setCreditorDeleteConfirmationPopup(true);
                                            } }), formdata.id ? (_jsx(VnButton, { icon: saveOutline, customClassName: 'vn-action-button', mode: 'primary', size: 'sm', 
                                            //type='submit'
                                            onClick: (e) => {
                                                setSubmitCreditures(true);
                                            }, customIconClassName: 'vn-action-button-icon', isDisabled: !handleRolePermission(Permission.LEVERANCIERS, PermissionType.Update) })) : (_jsx(VnButton, { icon: saveOutline, customClassName: 'vn-action-button', mode: 'primary', size: 'sm', type: 'submit', onClick: (e) => {
                                                setSubmitCreditures(true);
                                            }, customIconClassName: 'vn-action-button-icon', isDisabled: !handleRolePermission(Permission.LEVERANCIERS, PermissionType.Create) }))] })] }), _jsxs(Tabs, { className: 'vn-TabHeader', activeKey: activeTab, onSelect: handleTabChange, children: [_jsx(Tab, { eventKey: 'InfoTab', title: TabNotification('Info', infoTabErrorBorderColor, isInfoTabUnsaved), tabClassName: `${infoTabErrorBorderColor ? 'has-errors' : ''}
                             ${isInfoTabBold ? 'has-data' : ''}`, children: _jsx(InfoTab, { formData: formdata, errors: errors, onFieldChange: handleFieldChange, onToggelButtonChange: handleToggelButtonChange }) }), _jsx(Tab, { eventKey: 'ContactPersonTab', title: 'Contactpersonen', tabClassName: `${isContactPersonTabBold ? 'has-data' : ''}
                        `, disabled: id === undefined, children: _jsx(ContactPersonTab, { isContactPersonTabBold: handleContactPersonTabBold }) }), _jsx(Tab, { eventKey: 'NotiesTab', 
                                    // title='Notities/Afspraken'
                                    title: TabNotification('Notities/Afspraken', false, isNotesTabUnsaved), disabled: id === undefined, tabClassName: `${isNotesTabBold ? 'has-data' : ''}`, children: _jsx(NotesTab, { formData: formdata, errors: errors, onFieldChange: handleFieldChange, onToggelButtonChange: handleToggelButtonChange }) }), _jsx(Tab, { eventKey: 'AttachmentsTab', title: 'Bijlagen', tabClassName: `${isAttachmentTabBold ? 'has-data' : ''}
                         `, disabled: id === undefined, children: _jsx(AttachmentsTab, { formData: formdata, errors: errors, onFieldChange: handleFieldChange, onToggelButtonChange: handleToggelButtonChange, isAttachmentTabBold: handleAttachmentTabBold }) })] })] }), _jsx(VnConfirmationModel, { title: 'Alle tabbladgegevens van de crediteur worden permanent verwijderd. Weet u zeker dat u de crediteur wilt verwijderen?', onCancel: () => onCancelCreditorDeleteClicked(), onConfirm: () => handleCreditorDelete(), onOpen: isCreditorDeleteConfirmationPopup }), _jsx(VnNotificationModel, { message: creditorDeleteErrorMessage, onConfirm: () => onCancelCreditorDeleteClicked(), onOpen: isCreditorDeleteNotificationPopup })] }) }));
};
export default CreditureView;
